import { connect, useDispatch } from "react-redux";
import { Dispatch, Action } from "redux";
import { useTheme } from "styled-components";
import useIsMobile from "../../../../hooks/deviceChecker";
import { useLayout } from "../../../../provider/LayoutProvider";
import { useEffect, useState } from "react";
import Button from "../../../../components/Button";
import Units from "../../../../components/Units";
import {
  Content,
  Title,
  Cert,
  AdeccoTitle,
  CourseName,
  UserName,
  Actions,
} from "./styles";
import mcaLabelImage from "../../../../assets/images/mca.svg";
import Icon from "../../../../components/Icon";
import { useParams, useLocation } from "react-router-dom";
import { getOneCourse } from "../../../../store/actions/course";
import { CourseInDto } from "../../../../types/course.dto";
import { UserDto } from "../../../../types/user.dto";
import DownloadIcon from "../../../../assets/icons/icon-cool/outline/Download.svg";
import services from "../../../../services";
import { resetNewAnswerQuiz } from "../../../../store/actions/quiz";

interface ComponentProps {
  course: CourseInDto;
  courseStates?: {
    loading: boolean;
  };
}

const Component = ({ course }: ComponentProps) => {
  const theme = useTheme() as { [key: string]: { [key: string]: string } };
  const isMobile = useIsMobile();
  const params = useParams();
  const location = useLocation();
  const dispatch = useDispatch<Dispatch<Action>>();
  const [user, setUser] = useState<UserDto>();
  const [currentCourseId, setCurrentCourseId] = useState<number>();
  const { layout, setLayout } = useLayout();
  const [certificationDownload, setCertificationDownload] =
    useState<boolean>(false);

  //Pendientes
  // Se debe verificar si el curso efectivamente esta finalizado
  // En caso que este finalizado, mostramos esta pantalla
  // En caso que no este finalizado, debemos redireccionar al usuario al punto en el que lo dejo

  //Pendientes 2
  // En el certificado se pide nombre y apellido del usuario, sera necesario implementar servicios, store y demas
  // Para poder ir a buscar dicha informacion a algun endpoint que dispongan desde API.

  //Pendiente 3
  // Dejar funcional el boton de descargar certificado.

  useEffect(() => {
    setLayout({
      ...layout,
      showSubHeader: false,
      showFilters: false,
      showSearchBar: false,
    });
  }, [isMobile, params, location]);

  useEffect(() => {
    if (params) {
      params?.idCourse && setCurrentCourseId(Number(params?.idCourse));
    }
  }, [params]);

  useEffect(() => {
    if (currentCourseId) {
      dispatch(getOneCourse({ idCourse: currentCourseId }));
    }
  }, [currentCourseId]);

  useEffect(() => {
    const user = sessionStorage.getItem("user");
    if (user) {
      const parsedUser = JSON.parse(user);
      setUser(parsedUser);
    }

    //dispatch(resetNewAnswerQuiz());
  }, []);

  const downloadCertificationPdf = () => {
    setCertificationDownload(true);
    services.certification
      .downloadCertification(course.labEnrollment[0].id)
      .then((response) => {
        const url = URL.createObjectURL(response);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${user?.nombre
          .charAt(0)
          .toUpperCase()}${user?.nombre.slice(1)} ${user?.apellido
            .charAt(0)
            .toUpperCase()}${user?.apellido.slice(1)}_${course.title}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        setCertificationDownload(false);
      });
  };

  return (
    <Content>
      <Title>{course?.title}</Title>
      <div style={{ height: 20 }} />
      <Cert>
        <AdeccoTitle>Certificado - Adecco LAB</AdeccoTitle>
        <div style={{ height: 10 }} />
        <CourseName>{course?.title}</CourseName>
        <div style={{ height: 10 }} />
        <UserName>
          {`${user?.nombre?.charAt(0)?.toUpperCase()}${user?.nombre?.slice(
            1
          )} ${user?.apellido?.charAt(0)?.toUpperCase()}${user?.apellido?.slice(
            1
          )}`}{" "}
          <img src={mcaLabelImage} width={31} alt="MCA" />
        </UserName>
        <div style={{ height: 10 }} />
      </Cert>
      <div style={{ height: 6 }} />
      <Actions>
        <Button
          type="button"
          loading={certificationDownload}
          disabled={certificationDownload}
          options={{
            skin: "primary",
            size: "lg",
            type: "filled",
          }}
          onClick={() => {
            downloadCertificationPdf();
          }}
        >
          <Icon icon={DownloadIcon} size="18px" color={theme.colors.White} />
        </Button>
      </Actions>
      <div style={{ height: 25 }} />
      <Units course={course} showNumbers={true} />
    </Content>
  );
};

const state = ({ courseStore }) => {
  const { data: course, states: courseStates } = courseStore.getOne;

  return {
    course,
    courseStates,
  };
};

export default connect(state)(Component);
